<template>
  <section class="white">
    <v-container>
      <v-row>
        <v-col
          v-for="(level, index) in packages"
          :key="level.name"
          class="level"
          cols="12"
          sm="4"
        >
          <div class="column" :class="index === 1 ? 'light-blue lighten-4' : 'light-blue lighten-5'">
            <h2 class="blue--text text--darken-2">
              {{ level.name }}
            </h2>

            <h3 v-if="level.info">
              {{ level.info }}
            </h3>

            <div
              v-for="feature in level.features"
              :key="feature"
              class="feature"
            >
              {{ feature }}
            </div>
            <div class="price">
              {{ level.price.monthly | number }} SEK
              <div>
                Pris per månad, per användare
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col>
          <p class="my-6">
            Betala årsvis för att få två månader gratis varje år
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center">
          <Signup-button :text="'Kom igång direkt'" :x-large="true" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import SignupButton from '@/components/SignupButton'

export default {

  components: {
    SignupButton,
  },
  props: {
  },
  data() {
    return {
      packages: [
        {
          name: 'CRM Core',
          info: 'Alla grunder:',
          price: {
            monthly: 280,
          },
          features: [
            'Obegränsat antal användare',
            'Obegränsat antal kunder',
            'Obegränsat antal affärer',
            'Obegränsat antal aktiviteter',
            'Obegränsat antal kontotyper',
            'Säljtavla med drag-and-drop',
          ],
        },
        {
          name: 'CRM Plus',
          info: 'Allt i CRM Core, och:',
          price: {
            monthly: 680,
          },
          features: [
            '3st Användarroller',
            'Styr användarrättigheter',
            'Preferenser',
            'Produkter på affärer',
            'Fördefinierade produkter',
            'Skicka email från kundkorten',
          ],
        },
        {
          name: 'CRM Pro',
          info: 'Allt i CRM Plus, och:',
          price: {
            monthly: 980,
          },
          features: [
            'Obegränsat antal användarroller',
            'Obegränsat antal teams',
            'Team Hierarki',
            'Sekvenser',
            'Schemalägga email-utskicken',
            // 'Kalender-koppling',
          ],
        },
      ],
    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  },
}
</script>

<style lang='scss' scoped>
  .level {
    padding: 0;

    &:first-of-type, &:last-of-type {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .column {
      height: 100%;
      position: relative;
      padding: 20px;
      padding-bottom: 100px;

      h2 {
        margin-bottom: 20px;
      }

      .price {
        position: absolute;
        bottom: 20px;

        font-size: 28px;

        div {
          font-size: 14px;
        }
      }

      &.level:not(:first-of-type):not(:last-of-type) h2 {
        padding-bottom: 10px;
      }
    }
    .feature {
      padding: 10px 0;
      font-size: 18px;
    }

  }
</style>
